import { render } from "./KuotaView.vue?vue&type=template&id=966779fe"
import script from "./KuotaView.vue?vue&type=script&lang=js"
export * from "./KuotaView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__